
export type CreateFramebufferOptions = {
    width: number;
    height: number;
    texture: WebGLTexture;
};


export const createFramebuffer = (
    gl: WebGLRenderingContext,
    options: CreateFramebufferOptions
): WebGLFramebuffer => {
    const framebuffer = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
    gl.bindTexture(gl.TEXTURE_2D, options.texture);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, options.texture, 0);
    // @ts-ignore
    return framebuffer!;
};